<div class="select-kit-header-wrapper">

  {{component
    this.selectKit.options.selectedNameComponent
    tabindex=this.tabindex
    item=this.selectedContent
    selectKit=this.selectKit
    shouldDisplayClearableButton=this.shouldDisplayClearableButton
  }}

  {{#if this.subscriptionRequired}}
    <span class="subscription-label">{{i18n this.selectorLabel}}</span>
  {{/if}}

  {{d-icon this.caretIcon class="caret-icon"}}
</div>